import {useMemo} from 'react';

export default function useSocialName(socialUrl: string) {
  const matches = useMemo(() => socialUrl.match(/(?:https?:\/\/)?(?:www.)?(?:twitter|medium|facebook|vimeo|instagram)(?:.com\/)?([@a-zA-Z0-9-_]+)/im), [socialUrl]);
  return matches?.length ? matches[1] : socialUrl;
}
